import React from "react";
import { PropTypes } from 'prop-types';
class IndustryImage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			imageSrc: props.src || "images/ilve.png"
		}
		this.handleImageError = this.handleImageError.bind(this);
	}

	handleImageError() {
		try {
			this.setState({
				imageSrc: "images/ilve.png"
			})
		} catch (error) {
			console.error("Image fallback error:", error);
		}
	}

	render() {
		const { industryName } = this.props;
		const { imageSrc } = this.state;
		return (
            <img
                src={imageSrc}
                alt ={industryName}
                className="img-fluid"
                loading="lazy"
                onError={this.handleImageError}
            />
        )
	}
}

IndustryImage.propTypes = {
  src: PropTypes.string,
  industryName: PropTypes.string
};

export default IndustryImage;